import { gql } from "@apollo/client";

export const GetPackage = gql`
  query GetPackage($id: String!) {
    packageOne(id: $id) {
      name
      description
      isOrg
      isGeneric
      locations {
        id
        name
      }
      additionalPolicies {
        id
        name
      }
      initialCharges {
        id
        cost
        isTaxable
        isPostTax
        taxRates {
          id
          organizationTaxRate {
            name
          }
        }
        revenue {
          id
          name
        }
        fee {
          id
          name
        }
        isDiscountable
      }
      initialAllotments {
        id
        name
        credits
      }
      product {
        id
        imgUrl
        tags {
          id
          name
        }
        revenue {
          id
          name
        }
        isActive
      }
    }
  }
`;

export const GetPackagePage = gql`
  query GetPackagePage(
    $pagination: PaginationInput!
    $locationIds: [GenericConnectInput!]
  ) {
    PackagePage(pagination: $pagination, locationIds: $locationIds) {
      items {
        id
        name
        description
        createdDate
        isActive
        isOrg
      }
      totalRows
    }
  }
`;
